import React, { Component } from 'react';
import { addBonusDialogueStyles } from '../../styles';

import {
  Modal,
  Card,
  CardHeader,
  IconButton,
  Typography,
  CardContent,
  Grid,
  Button,
  WithStyles,
  withStyles
} from "@material-ui/core";

import {
  CloseOutlined as CloseIcon
} from '@material-ui/icons';

interface BonusWarningPopupProps extends WithStyles<typeof addBonusDialogueStyles> {
  isDialogOpen: boolean;
  handleClosePopUp: Function;
  handleSave: Function
}

interface BonusWarningPopupState {
  isDialogOpen: boolean;
}

class BonusWarningPopup extends Component<BonusWarningPopupProps, BonusWarningPopupState> {
  constructor(props: BonusWarningPopupProps) {
    super(props);
    this.state = {
      isDialogOpen: true
    };
  }

  render() {
    const { classes, isDialogOpen, handleClosePopUp, handleSave } = this.props;
    return (
      <Modal
        className={[
          classes.fontSizeLG,
          classes.fontWeight500,
          classes.modal,
        ].join(" ")}
        open={isDialogOpen}
      >
        <div >
          <Card >
            <CardHeader
              className={classes.modalHeader}
              action={
                <IconButton
                  aria-label="settings"
                  onClick={() => handleClosePopUp && handleClosePopUp()}
                >
                  <CloseIcon className={classes.fontSizeLG} />
                </IconButton>
              }
              title={
                <Typography
                  align="center"
                  className={[classes.fontWeight500, classes.fontSizeLG].join(
                    " "
                  )}
                >
                  Save then proceed
                    </Typography>
              }
            />
            <CardContent>
              <Grid
                container
                spacing={8}
                alignItems="center"
              >
                <Grid container direction="row" justify="center" alignItems="center" className={classes.mxWidth500}>
                  <Grid>
                    <img
                      src="/assets/svg/license_expired.svg"
                      alt="Bonus Info"
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  className={classes.mb1x}
                  alignItems="center"
                >
                  <Typography
                    variant="body1"
                    gutterBottom
                    className={classes.fontSizeMD}
                  >
                    You need to save the content before going back to the course list.
                    This will help you to retain your data.
                       </Typography>
                </Grid>
              </Grid>
              <Grid item container justify="space-between" alignItems="center">
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => handleClosePopUp()}
                // aria-label="outlined primary button group"
                >
                  cancel
                    </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleSave()}
                >
                  Save
                    </Button>
              </Grid>
            </CardContent>
          </Card>
        </div>
      </Modal>
    );
  }
}

// @ts-ignore
export default withStyles(addBonusDialogueStyles)(BonusWarningPopup);